module.exports = {"token":"6153A6FA0E4880D9B8D0BE4720F78E895265D0A9","login":"johnny","password":"monsupermotdepasse","state":"pause","resources":[]}


//////////////////
// WEBPACK FOOTER
// ./src/assets/json/configuration01.json
// module id = c0fK
// module chunks = 1